// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { filecoinHyperspace as _filecoinHyperspace } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the filecoinHyperspace chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 3141
 * Chain Name: Filecoin Hyperspace
 * Default Block Explorer: https://hyperspace.filfox.info/en
 * Default RPC URL: https://api.hyperspace.node.glif.io/rpc/v1
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { filecoinHyperspace } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: filecoinHyperspace,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const filecoinHyperspace = createCommon({
	..._filecoinHyperspace,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
